import React from 'react';
export function Disclaimer() {
  return <footer className="w-full bg-navy-950 px-4 pb-32 pt-12 text-white/60" data-id="element-129" data-mp="223ikeqta8qd6">
      <div className="mx-auto max-w-3xl space-y-3 text-xs leading-relaxed sm:text-sm" data-id="element-130" data-mp="pbpjt7ixbys2">
        <p className="font-display text-sm font-black uppercase text-white/85" data-id="element-131" data-mp="140cag5e04cyl">Important clinical disclaimer</p>
        <p data-id="element-132" data-mp="z7sl6b5ybtdy">
          This digital resource is intended exclusively for appropriately qualified healthcare professionals. It
          provides educational workflow and documentation support and does not constitute individualized medical
          advice, diagnosis, treatment instructions, or emergency management guidance.
        </p>
        <p data-id="element-133" data-mp="1mvsmu64sx47b">
          Clinical decisions must be based on professional judgment, current evidence, applicable regulations,
          established institutional protocols, and the patient's individual circumstances.
        </p>
        <p data-id="element-134" data-mp="3jqot371y1fc1">
          Potentially serious or rapidly progressing complications require timely assessment and escalation according
          to applicable clinical protocols. The resource must not delay emergency evaluation or specialist referral.
        </p>
        <p className="pt-4 text-white/40" data-id="element-135" data-mp="1ehhtlswfdqxw">© {new Date().getFullYear()} Aesthetic Laser Complications Decision Blueprint™. All rights reserved.</p>
      </div>
    </footer>;
}